module.exports = __webpack_public_path__ + "static/media/SL 15.198fea04.mp3";